export enum BroadcastNotificationTypes {
  Banner = 1,
  Notification = 2,
  TopStrip = 3
}
